export default {"src":"/_next/static/media/direction.672edd0e.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};